import { render, staticRenderFns } from "./HistoryOppan.vue?vue&type=template&id=15f221a8&scoped=true"
import script from "./HistoryOppan.vue?vue&type=script&lang=js"
export * from "./HistoryOppan.vue?vue&type=script&lang=js"
import style0 from "./HistoryOppan.vue?vue&type=style&index=0&id=15f221a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f221a8",
  null
  
)

export default component.exports